import { render, staticRenderFns } from "./CustomerProperties.vue?vue&type=template&id=8b3f6068&"
import script from "./CustomerProperties.vue?vue&type=script&lang=js&"
export * from "./CustomerProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports